import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Micro as CoreMicro } from '@vds-core/typography';
import BAUConfig from './config';
import { Fonts } from '../../fonts';

var Micro = function Micro(props) {
  return /*#__PURE__*/React.createElement(CoreMicro, _extends({}, props, {
    config: BAUConfig,
    fontsConfig: Fonts
  }));
};

export default Micro;